import { PropsWithChildren } from 'react'
import { Button } from '~/components/elements/Button'
import { MonitorIcon } from '~/components/icons/generated/MonitorIcon'
import { SearchIcon } from '~/components/icons/generated/SearchIcon'
import { ShopIcon } from '~/components/icons/generated/ShopIcon'

type ButtonWithIcon = {
  icon: React.ReactElement
} & React.ComponentProps<typeof Button>
const ButtonWithIcon: React.FC<PropsWithChildren<ButtonWithIcon>> = ({
  icon,
  children,
  ...props
}) => {
  return (
    <Button {...props} color="outlined">
      <div className="flex h-[34px] items-center text-[13px] font-bold text-gray-600">
        <span className="flex h-full w-[34px] items-center justify-center border-r border-gray-300">
          {icon}
        </span>
        <span className="grow">{children}</span>
      </div>
    </Button>
  )
}

type Props = {
  brand: {
    id: number
    name: string
    name_kana?: string
    concept?: string
    url?: string
  }
}

export const BrandIntroduction: React.FC<Props> = ({ brand }) => {
  return (
    <section className="w-[414px] rounded-[3px] border border-gray-300 bg-white p-[23px] pt-[25px]">
      <h2 className="text-[16px] font-bold leading-none">ブランド紹介</h2>
      <h3 className="break-all pt-[13px] text-[18px] leading-[1.4]">
        <a href={`/item/?brand_id=${brand.id}`} className="hover:underline">
          {brand.name}
        </a>
        {brand.name_kana && (
          <span className="block pt-[6px] text-[12px] leading-[1.6] text-gray-600">
            {brand.name_kana}
          </span>
        )}
      </h3>
      {brand.concept && (
        <p className="whitespace-pre-wrap pt-4 text-[13px] leading-[1.6]">
          {brand.concept}
        </p>
      )}
      <div className="flex w-[285px] flex-col gap-[9px] pt-[17px]">
        <ButtonWithIcon
          href={`/item/?brand_id=${brand.id}`}
          icon={<SearchIcon className="h-4" />}
        >
          このブランドのアイテムを探す
        </ButtonWithIcon>
        <ButtonWithIcon
          href={`/shop/?brand_id=${brand.id}`}
          icon={<ShopIcon className="h-4" />}
        >
          このブランドの取り扱い店舗を探す
        </ButtonWithIcon>
        {brand.url && (
          <ButtonWithIcon
            href={brand.url}
            target="_blank"
            icon={<MonitorIcon className="h-4" />}
          >
            このブランドのオフィシャルサイト
          </ButtonWithIcon>
        )}
      </div>
    </section>
  )
}
